import {URLSearchParamsInit, useSearchParams} from "react-router-dom";

type paramValue = string //asdasdsa
type paramValueForUrl = string //?hash=asdasdsa

export const useCurrentSearchParam = (param: string):
    [
        paramValue,
        (nextInit: URLSearchParamsInit, navigateOptions?: { replace?: boolean | undefined; state?: any; } | undefined) => void,
        paramValueForUrl
    ] => {
    const [searchParams, setSearchParams] = useSearchParams();
    const paramValue = searchParams.get(param) || ''
    let paramValueForUrl = ''
    if (paramValue) {
        paramValueForUrl = `?${param}=${paramValue}`
    }
    return [paramValue, setSearchParams, paramValueForUrl]
}

